import { gql } from 'graphql-request'

export const GetSpeciGql = gql`
  query speci($speciId: UUID!) {
    speci(speciId: $speciId) {
      speci {
        id
        type
        lines {
          id
          number
          description
          traditionalDescription
          baleNumbers
          instructions
          originalInstructions
        }
        breeds
        woolStore
        classer
        classerComment
        consignmentStatus
        stationAreaManagerEmail
        stationAreaManagerFullName
        sentToWoolStoreAt
        sentToWoolStoreBy
      }
    }
  }
`
